let Const = {
  api_url: process.env.VUE_APP_BASE_API
}

export const TOTAL_PANEL_ROUTES = ["dashboard", "contract-list"];
export const TOTAL_PANEL_MOBILE_BREAKPOINT = 1200;

export default Const
